module.exports = __webpack_public_path__ + "static/media/bindEnterprise1.343c29e0.png";